import React, { PureComponent } from 'react'
import SubTypeButton from './SubTypeButton'
import ListOrMap from './ListButton'
import DownloadButton from './DownloadButton'
import CycloramaButton from './CycloramaButton'
import StreetviewButton from './StreetviewButton'
import { Segment } from 'semantic-ui-react'
import { enableCyclorama } from '../../../../config'

const CycloramaOrStreetView = () =>
  enableCyclorama ? <CycloramaButton /> : <StreetviewButton />

class OptionsButtons extends PureComponent {
  render() {
    return (
      <Segment.Group horizontal>
        <SubTypeButton />
        <ListOrMap />
        <DownloadButton />
        <CycloramaOrStreetView />
      </Segment.Group>
    )
  }
}

export default OptionsButtons



// WEBPACK FOOTER //
// ./src/components/Elements/SearchContent/OptionsButtons/index.jsx